import React from 'react'
import SALink from 'components/SALink'
import { slugify } from 'lib/slugify'
import type { ConnectorProps as BreadcrumbProps } from '../connectors/Breadcrumb'
import BreadcrumbConnector from '../connectors/Breadcrumb'
import { Breadcrumbs } from './styles'

const Component = (props: BreadcrumbProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { category, keyword } = props
  return (
    <Breadcrumbs>
      <SALink title='Home' href='/'>
        Home
      </SALink>

      <SALink title={`See artworks in ${category}`} href={`/${slugify(category)}`}>
        {category}
      </SALink>

      <span>{keyword}</span>
    </Breadcrumbs>
  )
}

export default BreadcrumbConnector(Component)